import { MenuItem } from 'primeng/api';
import { Permission, UserPermissionsService } from '../services';

export type MenuItemWithPermission = MenuItem & { permissions?: Permission };

export function filterMenuItems(
  items: MenuItemWithPermission[],
  userPermissionService: UserPermissionsService
) {
  return items
    .filter(x => (x.permissions ? userPermissionService.hasPermission(x.permissions) : true))
    .filter((x, i, arr) => !(x.separator && i > 0 && arr[i - 1].separator))
    .filter((x, i, arr) => !(x.separator && (i === 0 || i === arr.length - 1)))
}
